var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styles from './modal.module.css';
import clsx from 'clsx';
import ReactModal from 'react-modal';
export var ModalTypes;
(function (ModalTypes) {
    ModalTypes["DEFAULT"] = "default";
    ModalTypes["DANGER"] = "danger";
    ModalTypes["SUCCESS"] = "success";
})(ModalTypes || (ModalTypes = {}));
export var Modal = function (_a) {
    var children = _a.children, _b = _a.type, type = _b === void 0 ? 'default' : _b, onRequestClose = _a.onRequestClose, props = __rest(_a, ["children", "type", "onRequestClose"]);
    return (_jsx(ReactModal, __assign({ onRequestClose: onRequestClose, overlayClassName: styles.overlay, className: clsx(styles.container, styles[type]) }, props, { children: _jsx("div", __assign({ className: clsx(styles.body) }, { children: children })) })));
};
export default Modal;
